import { render, staticRenderFns } from "./PopulationTrendCard.vue?vue&type=template&id=3c522efe&"
import script from "./PopulationTrendCard.vue?vue&type=script&lang=js&"
export * from "./PopulationTrendCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports